// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import {
  AiCourseraCoachExternalCoachDisclosureLazyLoad,
  ExternalCoachDisclosure,
} from 'bundles/ai-course-coach/components';
import CoachChatEmbedded from 'bundles/ai-course-coach/components/CoachChatEmbedded';
import ExternalCoachActionButton from 'bundles/ai-course-coach/components/ExternalCoachActionButton';
import { ExternalCoachLauncher } from 'bundles/ai-course-coach/components/Launcher';
import { CoachPermissionsWrapper } from 'bundles/ai-course-coach/utils/CoachPermissionWrapper';

import type { ExternalCoachDisclosureProps } from './components/ExternalCoachDisclosure';

// component exports
export {
  CoachChatEmbedded,
  ExternalCoachDisclosure,
  CoachPermissionsWrapper,
  AiCourseraCoachExternalCoachDisclosureLazyLoad,
  ExternalCoachLauncher,
  ExternalCoachActionButton,
};

// type exports
export type { ExternalCoachDisclosureProps };
